import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { getTargets } from "../api/targetsApi"
import type { TargetListFilters, TargetListItem } from "@/types"
import { emptyPage } from "@/types"

export const TARGETS_LIST_QUERY_KEY = "targets-list"

export const useTargets = (filters: TargetListFilters) => {
  return useQuery({
    queryKey: [TARGETS_LIST_QUERY_KEY, ...Object.values(filters)],
    queryFn: () => getTargets(filters),
    placeholderData: keepPreviousData,
    initialData: emptyPage<TargetListItem>,
  })
}
